import axios from 'axios'
import NProgress from 'nprogress'
import qs from 'qs'
import 'nprogress/nprogress.css'

const service = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : '/api',
    timeout: 60000,
    // maxContentLength: 20000,
})

service.interceptors.request.use(
    config => {
        NProgress.start()
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
        }
        const contentType = config.headers['Content-Type']
        if (config.method === 'post' && contentType === undefined) {
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
            config.data = qs.stringify(config.data)
        }
        return config
    },
    (error: any) => {
        NProgress.done()
        console.log(error)
        return Promise.reject(error)
    },
)

service.interceptors.response.use(
    (response: any) => {
        NProgress.done()
        const res = response.data
        return res
    },
    (error: any) => {
        NProgress.done()
        console.error(error)
        return Promise.reject(error)
    },
)

export default service
